import styled, { css } from 'styled-components'

import mediaqueries from '../../styles/media'

/**
 * Example:
 * <Heading.h1>Lorem Ipsum</Heading.h1>
 */

const commonStyles = (p) => css`
  color: ${p.theme.colors.headings};
  font-family: ${p.theme.fonts.headings};
`

const h1 = styled.h1`
  word-break: keep-all;
  font-size: 52px;
  line-height: 1.15;
  font-weight: bold;
  ${commonStyles};

  ${mediaqueries.desktop`
    font-size: 38px;
    line-height: 1.2;
  `};

  ${mediaqueries.phablet`
    font-size: 32px;
    line-height: 1.3;
  `};
`

const h2 = styled.h2`
  word-break: keep-all;
  font-size: 32px;
  line-height: 1.333;
  font-weight: bold;
  ${commonStyles};

  ${mediaqueries.tablet`
    font-size: 24px;
    line-height: 1.45;
  `};

  ${mediaqueries.phablet`
    font-size: 22px;
  `};
`

const h3 = styled.h3`
  word-break: keep-all;
  font-size: 24px;
  line-height: 1.45;
  font-weight: bold;
  ${commonStyles};

  ${mediaqueries.tablet`
    font-size: 22px;
  `};

  ${mediaqueries.phablet`
    font-size: 20px;
  `};
`

const h4 = styled.h4`
  word-break: keep-all;
  font-size: 18px;
  line-height: 1.45;
  font-weight: bold;
  ${commonStyles};

  ${mediaqueries.phablet`
    font-size: 16px;
  `};
`

const h5 = styled.h5`
  color: ${(p) => p.theme.colors.brand};
  font-family: ${(p) => p.theme.fonts.serif};
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 2px;
  word-break: keep-all;
  font-size: 20px;
  line-height: 1.45;
  text-align: center;

  ${mediaqueries.tablet`
    font-size: 18px;
  `};

  ${mediaqueries.phablet`
    font-size: 16px;
  `};
`

const h6 = styled.h6`
  word-break: keep-all;
  font-size: 14px;
  line-height: 1.45;
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding-bottom: 20px;
  ${commonStyles};
  font-family: ${(p) => p.theme.fonts.menu};

  ${mediaqueries.phablet`
    font-size: 12px;
  `};
`

export default {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6
}
